import React, { useState } from "react";
import { MernDevFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const MernDevelopers = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  return (<>
    <Helmet>
      <meta name="description" content="Hire certified MERN Stack developers in India to build secure, high-performance web apps. Get a free consultation and start your project with trusted experts."/>
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Hire MERN Stack Developers in India | Free Consultation | Ayanshtech Solutions"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/hire-mern-developers"/>
<meta property="og:description" content="Hire certified MERN Stack developers in India to build secure, high-performance web apps. Get a free consultation and start your project with trusted experts."/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Hire MERN Stack Developers in India | Free Consultation | Ayanshtech Solutions"/>
<meta name="twitter:description" content="Hire certified MERN Stack developers in India to build secure, high-performance web apps. Get a free consultation and start your project with trusted experts."/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/hire-mern-developers"/>
<title>Hire MERN Stack Developers in India | Free Consultation | Ayanshtech Solutions</title>
    </Helmet>
    <div className="flex flex-col items-center justify-center  p-6">
      <div className=" p-4 ">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-10  ">
          <div className="lg:w-3/4  lg:text-left mt-10">
            <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Hire MERN Stack Developers in India
            </h1>
            <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
              The MERN (MongoDB, Express, React, Node) stack is a powerful
              framework for developing modern, dynamic web and mobile
              applications. At Ayanshtech, our MERN developers specialize in
              building feature-rich applications tailored to meet your specific
              business goals.
              <br />
              <br />
              With expertise in modern JavaScript technologies and full-stack
              development, our team delivers scalable and efficient solutions.
              Whether you need an interactive user interface, seamless backend
              integration, or robust database management, our developers ensure
              smooth collaboration between all layers of your application.
              <br />
              <br />
              Ayanshtech’s MERN developers cater to diverse industries,
              providing tailored solutions that align with your vision. From
              startups to enterprises, we help you harness the potential of the
              MERN stack to create applications that are fast, secure, and
              future-ready. Let our dedicated developers turn your innovative
              ideas into impactful digital solutions today.
            </p>

            <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
              Starting from just <span className="font-bold">US $12/hour</span>
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-4"
            >
              Hire a MERN Stack Developer
            </button>
          </div>

          <div className="flex justify-center  mb-8 lg:mb-0 mt-5">
            <img
              src="\assets\images\headerSection\hireMernDev\img1.png"
              alt="MERN Stack Developers in India"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center  mt-10 p-4">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Skills and Expertise of Our MERN Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Partner with top-tier MERN developers to build fully functional and
          deployable applications. At Ayanshtech, we ensure you receive the best
          possible application solutions by hiring our expert MERN developers.
        </p>
      </div>

      <div className=" p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon4.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Solutions to your problem</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon5.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Proficiency in React.js</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon6.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Creation of flawless web applications</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon7.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Writing efficient code in less time</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon8.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Node.js knowledge</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon9.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Meticulous attention to detail</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon10.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Experience with Express.js</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon11.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Strong knowledge of MongoDB</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon12.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Skilled in Front End development</p>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Experienced MERN Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold max-w-6xl mx-auto p-4">
          At Ayanshtech, our MERN developers bring you a comprehensive
          understanding of the MERN stack, along with more creative solutions
          and faster time-to-market for your applications.
        </p>
      </div>

      <div className=" p-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="\assets\images\headerSection\hireMernDev\img2.webp"
              alt="Laptop with graph"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon13.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Efficient development process with a plug & play approach to
                  speed up app delivery
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon14.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Development of interactive and user-friendly web and mobile
                  applications using MERN technologies
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon15.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Scalable, cost-effective solutions designed to work flawlessly
                  across multiple platforms
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Creation of secure, robust native applications that provide an
                  exceptional user experience
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      <div className="max-w-3xl mx-auto p-4 mt-10 w-full ">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
          FAQs
        </h2>
        {MernDevFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      <div id="contact-section">
        {" "}
        <Contact />
      </div>

      <GetInTouch />
    </div>
  </>);
};

export default MernDevelopers;
